module.exports = __webpack_public_path__ + "static/media/logowhite.3b22e417.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/logowhite.svg
// module id = 121
// module chunks = 0